import { render, staticRenderFns } from "./BucketSettingsEntries.vue?vue&type=template&id=19297902&scoped=true&"
import script from "./BucketSettingsEntries.vue?vue&type=script&lang=js&"
export * from "./BucketSettingsEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19297902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19297902')) {
      api.createRecord('19297902', component.options)
    } else {
      api.reload('19297902', component.options)
    }
    module.hot.accept("./BucketSettingsEntries.vue?vue&type=template&id=19297902&scoped=true&", function () {
      api.rerender('19297902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/Header/BucketSettingsEntries.vue"
export default component.exports